import React__default from 'react';
import { Loader } from './styles.js';

function Spinner(props) {
    return (React__default.createElement(Loader, Object.assign({}, props, { role: "spinner", "aria-valuetext": "Working\u2026", "aria-roledescription": "spinner", "aria-live": "assertive", "aria-busy": "true", "aria-valuemin": 0, "aria-valuemax": 100 })));
}

export { Spinner };
